class HeroCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const slidesCount = Number.parseInt(this.dataset.slidesCount);

    let carouselInstance = {};

    if (slidesCount <= 1) {
      return;
    }

    import('@glidejs/glide').then(module => {
      const Glide = module.default;

      carouselInstance = new Glide(this, {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        autoplay: 5000,
        gap: 0
      });

      carouselInstance.mount();
    });
  }
}

customElements.get('hero-carousel') ||
  customElements.define('hero-carousel', HeroCarousel);
